import React from 'react'
import Grid from '@mui/material/Grid'
import TextField from '@mui/material/TextField'

const Dose = ({ moduleValues, setModuleValues }) => (
  <Grid item xs={12} md={6} lg={3}>
    <TextField
      label="Dose"
      fullWidth
      value={moduleValues?.['Dose'] ?? ''}
      onChange={(e) =>
        setModuleValues((prev) => ({
          ...prev,
          ['Dose']: e.target.value,
        }))
      }
    />
  </Grid>
)

export default Dose
